import {combineReducers} from 'redux'
import {dates} from '../../../../commons/reducers/dates'
import {demoEvents} from '../../../../commons/reducers/demo-events'
import {environment} from '../../../../commons/reducers/environment'
import {installedApps} from '../../../../commons/reducers/installed-apps'
import {instance} from '../../../../commons/reducers/instance'
import {multilingual} from '../../../../commons/reducers/multilingual'
import {State} from '../types/state'
import {calendarLayout} from './calendar-layout'
import {categories} from './categories'
import {component} from './component'
import {events} from './events'
import {layout} from './layout'
import {memberLoggedIn} from './member-logged-in'
import {members} from './members'
import {membershipOffers} from './membership-offers'
import {owner} from './owner'
import {siteSettings} from './site-settings'
import {totalGuests} from './total-guests'
import {dynamicVeloOverrides} from './velo-overrides'

export default combineReducers<State>({
  events,
  component,
  siteSettings,
  environment,
  layout,
  calendarLayout,
  categories,
  demoEvents,
  multilingual,
  instance,
  owner,
  memberLoggedIn,
  members,
  membershipOffers,
  totalGuests,
  dates,
  dynamicVeloOverrides,
  installedApps,
})
